import React from 'react';
import { Box } from '@mui/material';
import { ReportingFilterBar } from '../../ui/components/reporting';
import { ReportingHeader, ReportingTabsNav } from './components';
import { ReportingOutlet } from './containers';
import { useReportingFilters, useReportingRouting } from './hooks';

/**
 * Reporting feature composition root.
 * Integrates routed tabs navigation, filter coordinator, and the routed sub-views outlet.
 */
export const ReportingPage = () => {
  const { activeTab, handleTabChange } = useReportingRouting();
  const { filters, setFilters, departments, jobTitles } = useReportingFilters();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%', bgcolor: 'background.default' }}>
      <ReportingHeader />

      <ReportingFilterBar
        filters={filters}
        onChange={setFilters}
        departments={departments}
        jobTitles={jobTitles}
      />

      <ReportingTabsNav activeTab={activeTab} onChange={handleTabChange} />

      <Box
        component="main"
        role="tabpanel"
        id={`reporting-tabpanel-${activeTab}`}
        aria-labelledby={`reporting-tab-${activeTab}`}
        sx={{ flex: 1, p: { xs: 2, sm: 3 } }}
      >
        <ReportingOutlet filters={filters} />
      </Box>
    </Box>
  );
};
